import { ChevronsDown } from "lucide-react";

type HomeSkipProps = {
  /** 跳转目标区块的 id。 */
  targetId: string;
  label: string;
  visible: boolean;
  className?: string;
};

/** 置顶滚动区块里的“跳过”按钮：给不想看完演示的用户一个直达下一屏的出口。 */
export function HomeSkip({ targetId, label, visible, className = "" }: HomeSkipProps) {
  const skip = () => {
    const target = document.getElementById(targetId);
    if (!target) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY, behavior: reduced ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      className={`home-skip${visible ? " is-visible" : ""} ${className}`.trim()}
      onClick={skip}
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
    >
      {label}
      <ChevronsDown size={16} strokeWidth={1.8} />
    </button>
  );
}
